@import './styles/variables.less';

@line-height: 3px;

.sc-navbar {
  @media (min-width: @width-sm) {
      display: none;
  }
}
header {
    height: auto;
    @media (min-width: @width-sm) {
        height: 100px;
        padding: (2 * @margin);
    }
}

.sc-logo {
    height: 40px;
    @media (min-width: @width-sm) {
        height: 50px;
    }
}

.sc-line {
    position: relative;
    height: @line-height;
    margin-bottom: calc(@line-height / 2);

    &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: @line-height;
        transform-origin: 100% 0;
        transform: skew(-45deg);
        z-index: -1;
    }

    &.sc-line-blue {
        &:after {
        background: @sc-blue;
        }
    }

    &.sc-line-green {
        width: calc(100% - (@line-height + 1px));
        &:after {
        background: @sc-green;
        }
    }

    &.sc-line-orange {
        width: calc(100% - 2 * (@line-height + 1px));
        &:after {
        background: @sc-orange;
        }
    }
}

.sc-content {
    padding-top: (2 * @margin);
    padding-bottom: (2 * @margin);
    min-height: 250px;

    @media (min-width: @width-sm) {
        min-height: 500px;
    }
}

footer {
    padding-top: @margin;
    @padding-bottom: @margin;
}
